<template>
    <v-content :class="`account-company`" v-if="user">
        <h2>
            <typo name="title-30-normal">
                Société
            </typo>
        </h2>
        <sep name="M"></sep>
        <v-card elevation="0">
            <v-card-subtitle>
                <typo name="title-18-bold">{{ user.company.name }}</typo>
            </v-card-subtitle>
            <v-card-text>
                <typo name="body-16-normal">{{ user.company.address }}</typo>
                <br/>
                <typo name="body-16-normal">{{ user.company.postCode }}</typo> 
                <typo name="body-16-normal">{{ user.company.town }}</typo>
            </v-card-text>
        </v-card>
    </v-content>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: ["user"]
    })
</script>

<style lang="sass" scoped>
    
    .typo
        color: $color-secondary
</style>